module.exports = __webpack_public_path__ + "img/student2.3635c998.svg";